export default __webpack_public_path__ + "static/media/teach_three.11fa9ba1.png";